import { Localized } from "@fluent/react";
import { Button, ButtonGroup } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setLanguage } from "../../store/slices/locale";

// LangSwitch does not have any styling itself. It is expected to give a
// className and restyle it appropriately. LangSwitch will contain an unordered
// list of buttons.
export default function LangSwitcher() {
	const currLang = useAppSelector(state => state.locale.language);
	const dispatch = useAppDispatch();

	return <ButtonGroup variant="text" fullWidth={true}>
		{currLang !== 'da-DK' &&
			<Localized id="lang-switch-danish">
				<Button lang="da-DK" onClick={() => dispatch(setLanguage("da-DK"))} />
			</Localized>
		}
		{currLang !== 'en-GB' &&
			<Localized id="lang-switch-english">
				<Button lang="en-GB" onClick={() => dispatch(setLanguage("en-GB"))} />
			</Localized>
		}
		{currLang !== 'nl-NL' &&
			<Localized id="lang-switch-dutch">
				<Button lang="nl-NL" onClick={() => dispatch(setLanguage("nl-NL"))} />
			</Localized>
		}
	</ButtonGroup>
}
